import {Component, Input} from '@angular/core';

@Component({
    selector: 'tfl-error-block',
    template: `
        <div>
            <div *ngIf="title" class="title">
                {{ title }}
            </div>
            <div><ng-content></ng-content></div>
        </div>
    `
})
export class ErrorBlock {
    @Input('title') title: string = '';
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/modules/components/error/error.block.ts